var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.dialogCreateVOD
        ? _c("CrearVODModal", { on: { cerrar: _vm.handleCierreModalCrear } })
        : _vm._e(),
      _vm.dialogDetailVOD
        ? _c("DetalleVODModal", {
            attrs: { selectedVOD: _vm.selectedDetailVOD },
            on: { cerrar: _vm.handleCloseModalDetail }
          })
        : _vm._e(),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "700",
            "max-height": "700",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.openVideo,
            callback: function($$v) {
              _vm.openVideo = $$v
            },
            expression: "openVideo"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "vCardDialogVideo", shaped: "", outlined: "" } },
            [
              _c("div", { attrs: { id: "headerDialogVideo" } }, [
                _c("div", { staticStyle: { "margin-left": "2%" } }, [
                  _c("h2", { staticClass: "textstyle" }, [
                    _vm._v(_vm._s(_vm.titleDialog))
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticStyle: { "margin-left": "auto", "margin-right": "0" }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "", dark: "" },
                        on: {
                          click: function($event) {
                            _vm.openVideo = false
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("close")])],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { attrs: { id: "bodyDialogVideo" } },
                [
                  _c(
                    "video",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isDownload,
                          expression: "!isDownload"
                        }
                      ],
                      attrs: {
                        src: _vm.videoUrl,
                        controls: "",
                        id: "videoDialog"
                      }
                    },
                    [
                      _c("source", {
                        attrs: { src: _vm.videoUrl, type: "video/mp4" }
                      })
                    ]
                  ),
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isDownload,
                          expression: "isDownload"
                        }
                      ],
                      attrs: {
                        href: _vm.videoUrl,
                        id: "btnDownloadDialog",
                        color: "#27488E",
                        dark: ""
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("upload")]),
                      _vm._v("Descargar video")
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "margin-top": "1%" } },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        staticClass: "tfClass",
                        attrs: {
                          contentClass: "vAutoCom",
                          multiple: "",
                          items: _vm.formFields.patent.items,
                          label: _vm.formFields.patent.label,
                          "item-text": "desc",
                          "item-value": "desc"
                        },
                        on: { change: _vm.changeAutoComplete },
                        scopedSlots: _vm._u([
                          {
                            key: "prepend-item",
                            fn: function() {
                              return [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c("v-checkbox", {
                                      attrs: { label: "Seleccionar todos" },
                                      on: {
                                        change: function($event) {
                                          return _vm.selectAllPatent()
                                        }
                                      },
                                      model: {
                                        value: _vm.checkAllPatent,
                                        callback: function($$v) {
                                          _vm.checkAllPatent = $$v
                                        },
                                        expression: "checkAllPatent"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("v-divider")
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "selection",
                            fn: function(ref) {
                              var item = ref.item
                              var index = ref.index
                              return [
                                index === 0
                                  ? _c("v-chip", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.textoComprimido(item.desc))
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                index === 1
                                  ? _c(
                                      "span",
                                      { staticClass: "grey--text caption" },
                                      [
                                        _vm._v(
                                          "(+" +
                                            _vm._s(
                                              _vm.patentsSelect.length - 1
                                            ) +
                                            " otros)"
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "item",
                            fn: function(data) {
                              return [
                                _c(
                                  "v-list-tile",
                                  _vm._g(
                                    _vm._b(
                                      {},
                                      "v-list-tile",
                                      data.tile.props,
                                      false
                                    ),
                                    data.tile.on
                                  ),
                                  [
                                    _c(
                                      "v-list-tile-action",
                                      {
                                        staticStyle: {
                                          "padding-top": "13px !important",
                                          "min-width": "0px !important"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.changePatentCheckbox(
                                              data.item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("v-checkbox", {
                                          model: {
                                            value: data.item.selected,
                                            callback: function($$v) {
                                              _vm.$set(
                                                data.item,
                                                "selected",
                                                $$v
                                              )
                                            },
                                            expression: "data.item.selected"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-tile-content",
                                      {
                                        staticStyle: {
                                          overflow: "visible !important"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "margin-left": "5%",
                                              "margin-right": "5%",
                                              cursor: "pointer !important"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.changePatent(
                                                  data.item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "material-icons",
                                              style: _vm.getHtmlFromState(
                                                data.item.estado
                                              ),
                                              attrs: {
                                                id: "5545",
                                                title: _vm.getStateString(
                                                  data.item.estado
                                                )
                                              }
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "tooltip",
                                                staticStyle: {
                                                  "padding-left": "16px",
                                                  "margin-top": "2%"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "4%"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.textoComprimido(
                                                            data.item.patente +
                                                              " [" +
                                                              data.item.cod +
                                                              "]"
                                                          )
                                                        )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  " \n                      "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "tooltiptext"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.item.patente +
                                                          " [" +
                                                          data.item.cod +
                                                          "]"
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.formFields.patent.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.patent, "value", $$v)
                          },
                          expression: "formFields.patent.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("DateComponent", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "tfClass",
                        attrs: {
                          label: _vm.formFields.dateStart.label,
                          "data-vv-name": "fechaRequerida",
                          "error-messages": _vm.errors.collect(
                            "fechaRequerida"
                          ),
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.dateStart.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.dateStart, "value", $$v)
                          },
                          expression: "formFields.dateStart.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("TimeComponent", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "tfClass",
                        attrs: {
                          label: _vm.formFields.timeStart.label,
                          "data-vv-name": "horaRequerida",
                          "error-messages": _vm.errors.collect("horaRequerida"),
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.timeStart.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.timeStart, "value", $$v)
                          },
                          expression: "formFields.timeStart.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "text-align": "end" },
                      attrs: { sm3: "", md3: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: { height: "48px" },
                          attrs: { color: "#ffe800" },
                          on: { click: _vm.handleClickCreate }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: {
                                "font-size": "160%",
                                "margin-right": "7% !important"
                              },
                              attrs: { dark: "", left: "" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c(
                            "span",
                            { staticStyle: { "font-size": "1.5vmin" } },
                            [_vm._v("Crear VOD")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("DateComponent", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "tfClass",
                        attrs: {
                          label: _vm.formFields.dateEnd.label,
                          "data-vv-name": "fechaFinRequerida",
                          "error-messages": _vm.errors.collect(
                            "fechaFinRequerida"
                          ),
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.dateEnd.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                          },
                          expression: "formFields.dateEnd.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("TimeComponent", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass: "tfClass",
                        attrs: {
                          label: _vm.formFields.timeEnd.label,
                          "data-vv-name": "horaFinRequerida",
                          "error-messages": _vm.errors.collect(
                            "horaFinRequerida"
                          ),
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.timeEnd.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.timeEnd, "value", $$v)
                          },
                          expression: "formFields.timeEnd.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        staticClass: "tfClass",
                        attrs: {
                          items: _vm.formFields.channels.items,
                          label: _vm.formFields.channels.label,
                          "item-text": "desc",
                          "item-value": "cod"
                        },
                        model: {
                          value: _vm.formFields.channels.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.channels, "value", $$v)
                          },
                          expression: "formFields.channels.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm3: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        staticClass: "tfClass",
                        attrs: {
                          items: _vm.formFields.state.items,
                          label: _vm.formFields.state.label,
                          "item-text": "desc",
                          "item-value": "cod"
                        },
                        model: {
                          value: _vm.formFields.state.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.state, "value", $$v)
                          },
                          expression: "formFields.state.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                      attrs: { sm3: "", md3: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        { attrs: { icon: "" }, on: { click: _vm.handleClick } },
                        [_c("v-icon", [_vm._v("search")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._m(0),
      _c("div", { staticClass: "bodyDiv" }, [
        _c(
          "div",
          { staticClass: "gridcard rounded-card" },
          [
            _c("GridComponent", {
              ref: "gridComponent",
              staticClass: "ag-theme-material",
              attrs: { id: "gridComponent", gridOptions: _vm.gridOptions }
            })
          ],
          1
        )
      ]),
      _vm.modalViewDetail
        ? _c("CamaraVODVerDetalle", {
            attrs: { dataTraza: _vm.dataTraza },
            on: { cerrar: _vm.handleCloseModalDetail }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "h3",
        {
          staticStyle: {
            "font-size": "1.6vmin",
            "font-weight": "400",
            "margin-top": "30px"
          }
        },
        [
          _vm._v(
            "\n      *Presione sobre una fila para expandir sus detalles\n    "
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }